import { render } from "./ClientProposalExpired.vue?vue&type=template&id=25b525aa&scoped=true"
import script from "./ClientProposalExpired.vue?vue&type=script&lang=js"
export * from "./ClientProposalExpired.vue?vue&type=script&lang=js"

import "./ClientProposalExpired.vue?vue&type=style&index=0&id=25b525aa&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b525aa"]])

export default __exports__